import { render, staticRenderFns } from "./Merchandising2025Lista.vue?vue&type=template&id=ca60322a&"
import script from "./Merchandising2025Lista.vue?vue&type=script&lang=js&"
export * from "./Merchandising2025Lista.vue?vue&type=script&lang=js&"
import style0 from "./Merchandising2025Lista.vue?vue&type=style&index=0&id=ca60322a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports